/**
 * Whether coach-tools lead-style mutations must include a solved reCAPTCHA before submit.
 *
 * `next dev` sets `NODE_ENV === 'development'` — we skip the widget and allow submit without
 * `X-PGA-RECAPTCHA` for faster local UX. Production bundles (including dev.pga.com / www),
 * `next start`, and Jest (`NODE_ENV=test`) still require a token when the form gates on it.
 */
export function isRecaptchaRequired() {
  return process.env.NODE_ENV !== 'development'
}
